import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'mwp-dialog-support',
    templateUrl: './support.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogSupportComponent {

    constructor(
        private dialogRef: MatDialogRef<DialogSupportComponent>,
    ) {
    }

    close(): void {
        this.dialogRef.close();
    }
}